import React from "react";
import { Box, Text, HStack, Tag } from "@chakra-ui/react";
import { ChapterHeading, Reveal } from "./story";

const chapters = [
  {
    year: "The spark",
    text: `It started with words, not code. Before I ever shipped a feature, I was explaining how technology works, authoring 150+ technical articles for GeeksforGeeks across JavaScript, Python, Java and C. Teaching a concept forces you to truly understand it, and that habit still shapes how I engineer today.`,
  },
  {
    year: "The craft",
    text: `Curiosity turned into building. I dove into the MERN stack, then stretched further during an internship at Salesken, shipping real interfaces alongside senior engineers and learning what production quality code actually feels like.`,
  },
  {
    year: "The mission",
    text: (
      <>
        Today I lead engineering for{" "}
        <Box as="span" fontWeight="800" color="#e6e9f0">
          letsworkwise
        </Box>
        , a B2B procurement platform. I took it from an outsourced codebase to a
        product we own, building the team and the tech (Next.js, Node.js,
        PostgreSQL, AWS) around it. Alongside, I'm pursuing my MCA at IIT Patna,
        sharpening the fundamentals behind the products I build.
      </>
    ),
  },
];

function About() {
  return (
    <Box id="About" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Chapter 01 · The Origin"
        title="How a curious writer became an engineer"
        subtitle="Every résumé is a list of dates. This is the story behind mine."
      />

      {/* narrative timeline */}
      <Box maxW="720px" mx="auto" position="relative">
        {/* vertical thread linking the beats */}
        <Box
          position="absolute"
          left="7px"
          top="10px"
          bottom="70px"
          w="2px"
          bgGradient="linear(to-b, #60A5FA, transparent)"
          display={{ base: "none", md: "block" }}
        />
        {chapters.map((c, i) => (
          <Reveal key={i} delay={i * 0.12} pl={{ base: 0, md: "34px" }} mb="28px" position="relative">
            <Box
              position="absolute"
              left="0"
              top="6px"
              w="16px"
              h="16px"
              borderRadius="full"
              bg="#0C111B"
              border="3px solid #60A5FA"
              display={{ base: "none", md: "block" }}
            />
            <Text
              fontSize="sm"
              fontWeight="800"
              color="#60A5FA"
              letterSpacing="0.1em"
              textTransform="uppercase"
              mb="6px"
            >
              {c.year}
            </Text>
            <Text color="#c2c9d6" fontSize={{ base: "sm", md: "md" }} lineHeight="1.9">
              {c.text}
            </Text>
          </Reveal>
        ))}

        <Reveal delay={0.3} pl={{ base: 0, md: "34px" }}>
          <HStack spacing={3} flexWrap="wrap">
            {["Curious", "Versatile", "Collaborative", "Lifelong learner"].map(
              (t) => (
                <Tag
                  key={t}
                  bg="rgba(96,165,250,0.12)"
                  color="#93C5FD"
                  border="1px solid rgba(96,165,250,0.3)"
                  borderRadius="full"
                  px="14px"
                  py="6px"
                  mb="8px"
                >
                  {t}
                </Tag>
              )
            )}
          </HStack>
        </Reveal>
      </Box>
    </Box>
  );
}

export default About;
